import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../api/analytics';

/**
 * AnalyticsTracker component
 *
 * This component automatically tracks page views when the route changes.
 * It should be placed in the main App component to track all route changes.
 *
 * Features:
 * - Tracks page views automatically on route changes
 * - Uses the route path as the page name
 * - Can be extended to track additional parameters
 */
export const AnalyticsTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Get page name from pathname (remove leading slash and use home if empty)
    const pageName = location.pathname === '/'
      ? 'home'
      : location.pathname.substring(1).replace(/\//g, '-') || 'unknown';

    // Track page view with current route information
    trackPageView(pageName, {
      // Add any additional parameters you want to track
      referrer: document.referrer || 'direct',
      search_query: location.search,
    });
  }, [location]);

  // This component doesn't render anything
  return null;
};
